<template>
  <div class="mobile-code flex">
    <el-input v-model="inputValue" prefix-icon="el-icon-message" placeholder="请输入验证码" clearable>
      <template slot="append">
        <el-button :loading="btnLoading" @click="sendCode">
          <span v-if="!sending">获取验证码</span>
          <span v-else>{{ interval - counter }}秒后重发</span>
        </el-button>
      </template>
    </el-input>
    <div class="icons flex justify-content-center align-items-center border radius5 pl-xs pr-xs pt-xs pb-xs ml-sm font-lg" :class="{big: size === 'big'}">
      <el-tooltip effect="dark" content="发送短信验证码" placement="top">
        <span class="icon-item pl-xs pr-xs radius5 mr-xs" :class="{active: innerVerifyWay === 1}" @click="verifyWayChange(1)"><i class="iconfont icon-message"></i></span>
      </el-tooltip>
      <el-tooltip effect="dark" content="发送语音验证码" placement="top">
        <span class="icon-item pl-xs pr-xs radius5" :class="{active: innerVerifyWay === 4}" @click="verifyWayChange(4)"><i class="iconfont icon-phone"></i></span>
      </el-tooltip>
    </div>
  </div>
</template>

<script>
import { codeSendApi } from "@/api/common/registerApi"
import { validateMobile } from "@/utils/validate"

export default {
  name: "MobileCode",
  props: {
    value: {
      type: String,
      default: ''
    },
    // 1=注册，2=重置密码，3=绑定手机号，4=登录
    scene: {
      type: Number,
      default: 1
    },
    // 1=短信验证，2=微信扫码，3=邮箱，4=语音验证码
    verifyWay: {
      type: Number,
      default: 1
    },
    mobile: {
      type: String,
      default: ''
    },
    validateMobileMsg: {
      type: String,
      default: ''
    },
    size: {
      type: String,
      default: '' // big | ''
    }
  },
  data() {
    return {
      sending: false,
      counter: 0,
      interval: 60,
      btnLoading: false,
    }
  },
  computed: {
    inputValue: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    },
    innerVerifyWay: {
      get() {
        return this.verifyWay
      },
      set(val) {
        this.$emit('update:verifyWay', val)
      }
    }
  },
  watch: {
    counter () {
      if (this.counter > this.interval) {
        this.sending = false
        this.counter = 0
        if (this.timer) {
          clearInterval(this.timer)
        }
      }
    }
  },
  methods: {
    sendCode () {
      if (this.sending) return
      if(!this.mobile) {
        this.$message.error('请输入11位手机号码')
        return
      }
      if (!validateMobile(this.mobile)) {
        this.$message.error('请输入正确的手机号码！')
        return
      }
      if (this.validateMobileMsg) {
        this.$message.error(this.validateMobileMsg)
        return
      }
      this.btnLoading = true
      const params = {
        receiver: this.mobile,
        scene: this.scene,
        verify_way: this.innerVerifyWay
      }
      codeSendApi(params).then((res) => {
        this.btnLoading = false
        if (!res.errno) {
          this.sending = true
          this.$message.success('验证码已发送到你的手机，1小时内有效！')
          this.timer = setInterval(() => {
            this.counter += 1
          }, 1000)
        } else {
          this.sending = false
          this.$message.error(res.message)
        }
      })
    },
    verifyWayChange (type) {
      this.innerVerifyWay = type
    }
  }
}
</script>

<style scoped lang="scss">
.mobile-code {
  .el-input {
    /deep/ .el-input-group__append {
      .el-button {
        padding-left: 6px;
        padding-right: 6px;
      }
    }
  }

  .icons {
    height: 36px;

    &.big {
      height: 40px;
    }

    .icon-item {
      line-height: initial;
      padding-top: 3px;
      padding-bottom: 3px;
      cursor: pointer;

      &.active {
        background-color: #EEEFF4;
      }
    }
  }
}
</style>
